// api handlers re-throw the raw response *string* on a 400
// and return undefined on anything else (500s, network failures), so callers
// cannot assume a shape. This unwraps whatever they are handed into something
// worth showing a user, and falls back when there is no readable message.

// Keys that carry machine codes rather than text meant for a user.
const CODE_KEYS = ["status", "code", "error_code", "errorCode", "statusCode"];

const MAX_MESSAGE_LENGTH = 200;

function isShowableText(text) {
  return Boolean(text) && text.length <= MAX_MESSAGE_LENGTH && !/[<>]/.test(text);
}

export function extractApiErrorMessage(err, fallback) {
  let payload = err;

  if (payload instanceof Error) return fallback;

  if (typeof payload === "string") {
    try {
      payload = JSON.parse(payload);
    } catch (e) {
      const text = payload.trim();
      return isShowableText(text) ? text : fallback;
    }
  }

  if (!payload || typeof payload !== "object") return fallback;

  const direct =
    payload.message || payload.reason || payload.error || payload.detail;
  if (typeof direct === "string" && direct.trim()) return direct.trim();

  // DRF answers with field maps: { password: ["This password is too common."] }
  const fieldError = Object.keys(payload).reduce((found, key) => {
    if (found || CODE_KEYS.includes(key)) return found;
    const value = payload[key];
    if (typeof value === "string" && value.trim()) return value;
    if (Array.isArray(value)) {
      return value.find((v) => typeof v === "string" && v.trim()) || found;
    }
    return found;
  }, undefined);

  return fieldError || fallback;
}

export default extractApiErrorMessage;
